<span class="tag bolt"
  ><img src="assets/images/icons/svg/ev-icon.svg" alt="icon" class="icon" /> {{ count }} EV{{
    count > 1 ? 's' : ''
  }}</span
>
